
import axios from 'axios';

export const FETCH_SHOP_OVERVIEW_REQUEST = 'FETCH_SHOP_OVERVIEW_REQUEST';
export const FETCH_SHOP_OVERVIEW_SUCCESS = 'FETCH_SHOP_OVERVIEW_SUCCESS';
export const FETCH_SHOP_OVERVIEW_FAILURE = 'FETCH_SHOP_OVERVIEW_FAILURE';

export const fetchShopOverviewRequest = () => {
  return{
    type: FETCH_SHOP_OVERVIEW_REQUEST
  };
};

export const fetchShopOverviewSuccess = shop => {
  return {
    type: FETCH_SHOP_OVERVIEW_SUCCESS,
    shop
  };
};
export const fetchShopOverviewFailure = error => {
  return {
    type: FETCH_SHOP_OVERVIEW_FAILURE,
    error
  };
};

export const fetchShopOverview = () => {
  return dispatch => {
    dispatch(fetchShopOverviewRequest());
    return axios(`${apiBase}/akkurat/v1/shop`)
    .then(response => {
      return dispatch(fetchShopOverviewSuccess(response.data))
    })
  };
};
